import {CouponQueueDetailDto} from 'rest'
import {OfferBadge} from 'components/template/OfferBadge'
import {Link} from 'react-router-dom'

interface Props {
  coupon: CouponQueueDetailDto
}

export const CouponCard = ({coupon}: Props) => {
  return (
    <div className="border border-gray-300 shadow-sm rounded-xl p-4  w-full my-4 hover:shadow-xl transition-shadow duration-300">
      <div className="relative w-full flex flex-col md:flex-row items-center justify-between mb-3 space-y-4 md:space-y-0">
        <div className="flex flex-col md:flex-row items-start space-y-2 md:space-x-4">
          <div className="coupon-offer">
            <OfferBadge
              prefix=""
              title={coupon.headline}
              suffix=""
              className="font-semibold text-lg text-gray-800"
            />
          </div>

          <div
            className="px-4 space-y-1 cursor-pointer"
            onClick={() => window.open(coupon.destinationUrl, '_blank')}>
            <p className="text-sm sm:text-base tracking-tight text-gray-700">
              {coupon.description}
            </p>

            <p className="text-sm sm:text-base font-medium text-gray-600">
              CODE: {coupon.code}
            </p>
          </div>
        </div>

        {/* Right: Edit Link */}
        <Link
          to={`/coupons/${coupon.couponId}`}
          className="mt-3 md:mt-0  font-semibold text-sm border rounded px-4 py-1 transition-colors duration-200 button edit">
          Edit
        </Link>
      </div>
    </div>
  )
}
